import axios from '../../../helpers/axios';
import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { QUERY_KEYS } from '../../../queries/query.keys';

export const useProductColumn = () => {
    return useQuery<string[], AxiosError>(QUERY_KEYS.PRODUCT_IMPORT_COLUMNS, () =>
        axios.get<string[]>('product/import/column/list').then((response) => response.data)
    );
};
